import { getAgoda } from "./functions/agoda.homes";
import { messagingClient } from "./functions/messagingClient";

const CCPA_PREFERENCES_KEY = "AppSettings.preferences";

let initializationPromise: Promise<void> | undefined;

const isCcpaOptOut = (): boolean => {
    try {
        const preferences = window.localStorage.getItem(CCPA_PREFERENCES_KEY);
        if (!preferences) return false;

        return JSON.parse(preferences).ccpa_status === "opt-out";
    } catch {
        return false;
    }
};

export const initializeGtm = (pageTypeId: number | null): Promise<void> => {
    const config = getAgoda().gtm;
    const gtmId = config?.id?.trim();
    const origin = config?.origin?.trim();

    if (!gtmId || !origin) return Promise.resolve();

    const whiteLabelId =
        typeof config.whiteLabelId === "number" && Number.isFinite(config.whiteLabelId) ? config.whiteLabelId : 1;

    initializationPromise ??= import("@agoda/gtm")
        .then(({ gtmService }) => {
            gtmService.init(gtmId, origin, pageTypeId ?? 0, isCcpaOptOut(), whiteLabelId, messagingClient);
        })
        .catch((error: unknown) => {
            initializationPromise = undefined;
            console.error("Failed to initialize Google Tag Manager:", error);
        });

    return initializationPromise;
};
